import { useEffect, useRef, useState } from "react";
import $ from "jquery";
import "daterangepicker/daterangepicker.css";
import moment from "moment";
import "daterangepicker";
import { useDispatch, useSelector } from "react-redux";
import { getPropertyList } from "../../Redux/Slices/BON-Frontend/propertyListSlice";
import { useNavigate } from "react-router-dom";

export const HomeBanner = () => {
  const inputRef = useRef(null);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const guestDropdownRef = useRef(null);
  const hotelDropdownRef = useRef(null);

  const [dateValue, setDateValue] = useState("Add Date");

  // ================= HOTEL DROPDOWN =================
  const [showHotelDropdown, setShowHotelDropdown] = useState(false);
  const [hotelSearch, setHotelSearch] = useState("");
  const [selectedHotel, setSelectedHotel] = useState(null);
  const [checkInDate, setCheckInDate] = useState(
    moment().format("YYYY-MM-DD")
  );

  const [checkOutDate, setCheckOutDate] = useState(
    moment().add(1, "days").format("YYYY-MM-DD")
  );
  const { properties, loading } = useSelector((state) => state.propertyList);

  // const [selectedHotel, setSelectedHotel] = useState(
  //   "Where do you want to stay?"
  // );


  useEffect(() => {
    dispatch(getPropertyList());
  }, [dispatch]);

  useEffect(() => {
    if (properties?.length > 0) {
      setSelectedHotel(properties[0]);
    }
  }, [properties]);

  const filteredProperties = properties?.filter((item) =>
    item.DisplayName?.toLowerCase().includes(
      hotelSearch.toLowerCase()
    )
  );

  // Guest States
  const [showGuestDropdown, setShowGuestDropdown] = useState(false);
  const [adults, setAdults] = useState(2);
  const [children, setChildren] = useState(0);
  const [rooms, setRooms] = useState(1);

  // ================= DATE PICKER =================
  useEffect(() => {
    const today = moment();
    const tomorrow = moment().add(1, "days");

    // Default Values
    setDateValue(
      `${today.format("ddd, MMM D")} - ${tomorrow.format("ddd, MMM D")}`
    );

    setCheckInDate(today.format("YYYY-MM-DD"));
    setCheckOutDate(tomorrow.format("YYYY-MM-DD"));

    const $input = $(inputRef.current);

    $input.daterangepicker(
      {
        autoUpdateInput: false,
        autoApply: true,
        opens: "center",
        startDate: today,
        endDate: tomorrow,
        minDate: today,
        locale: {
          cancelLabel: "Clear",
        },
      },
      function (start, end) {
        setDateValue(
          `${start.format("DD/MM/YYYY")} - ${end.format("DD/MM/YYYY")}`
        );

        setCheckInDate(start.format("YYYY-MM-DD"));
        setCheckOutDate(end.format("YYYY-MM-DD"));
      }
    );

    $input.on("apply.daterangepicker", function (ev, picker) {
      setDateValue(
        `${picker.startDate.format("ddd, MMM D")} - ${picker.endDate.format("ddd, MMM D")}`
      );

      setCheckInDate(
        picker.startDate.format("YYYY-MM-DD")
      );

      setCheckOutDate(
        picker.endDate.format("YYYY-MM-DD")
      );
    });

    $input.on("cancel.daterangepicker", function () {
      const today = moment();
      const tomorrow = moment().add(1, "days");

      const picker = $input.data("daterangepicker");

      picker.setStartDate(today);
      picker.setEndDate(tomorrow);

      setDateValue(
        `${today.format("ddd, MMM D")} - ${tomorrow.format("ddd, MMM D")}`
      );

      setCheckInDate(today.format("YYYY-MM-DD"));
      setCheckOutDate(tomorrow.format("YYYY-MM-DD"));
    });

    return () => {
      $input.off("apply.daterangepicker");
      $input.off("cancel.daterangepicker");
      $input.data("daterangepicker")?.remove();
    };
  }, []);

  const openPicker = () => {
    $(inputRef.current).trigger("click");
  };


  // ================= OUTSIDE CLICK CLOSE =================
  useEffect(() => {
    const handleClickOutside = (event) => {
      // Guest dropdown close
      if (
        guestDropdownRef.current &&
        !guestDropdownRef.current.contains(event.target)
      ) {
        setShowGuestDropdown(false);
      }

      // Hotel dropdown close
      if (
        hotelDropdownRef.current &&
        !hotelDropdownRef.current.contains(event.target)
      ) {
        setShowHotelDropdown(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  // ================= COUNTER =================
  const Counter = ({ label, value, setValue, min = 0 }) => {
    return (
      <div className="d-flex justify-content-between align-items-center mb-3">
        <div>
          <div
            style={{
              fontWeight: 600,
              fontSize: "15px",
            }}
          >
            {label}
          </div>
        </div>

        <div className="d-flex align-items-center gap-2">
          <button
            className="btn btn-light border"
            onClick={() => value > min && setValue(value - 1)}
            style={{
              width: 34,
              height: 34,
              borderRadius: "50%",
              padding: 0,
            }}
          >
            -
          </button>

          <span
            style={{
              minWidth: 20,
              textAlign: "center",
              fontWeight: 600,
            }}
          >
            {value}
          </span>

          <button
            className="btn btn-light border"
            onClick={() => setValue(value + 1)}
            style={{
              width: 34,
              height: 34,
              borderRadius: "50%",
              padding: 0,
            }}
          >
            +
          </button>
        </div>
      </div>
    );
  };


  const handleSearch = () => {
    if (!selectedHotel?.PID) {
      alert("Please select hotel");
      return;
    }

    navigate(`/Hotels/Home?pid=${encodeURIComponent(selectedHotel.PID)}`, {
     state: {
        PropertyID: selectedHotel.PropertyID,
        checkInDate,
        checkOutDate,
      },
    });
  };

  return (
    <>
      {/* ===== HERO ===== */}
      <section
        className="zzx_hero-section"
        style={{ paddingBottom: 90 }}
      >
        <div className="container">
          <div className="row align-items-center">
            <div className="col-lg-7">
              <div className="zzx_genius-badge">
                <i className="bi bi-lightning-charge-fill" />
                Genius Loyalty Rewards – Save up to 20%
              </div>

              <h1>
                Find Your Perfect Stay,
                <br />
                Anywhere in the World
              </h1>

              <p className="mt-3">
                Discover hotels, resorts, villas, and more at unbeatable
                prices.
              </p>
            </div>
          </div>

          {/* SEARCH BOX */}
          <div className="zzx_search-box mt-4">
            <div
              className="d-flex align-items-stretch gap-0"
              style={{ flexWrap: "wrap" }}
            >
              <div className="zzx_search-inner flex-grow-1">

                {/* HOTEL */}
                <div
                  className="zzx_search-field position-relative"
                  ref={hotelDropdownRef}
                >
                  <i className="bi bi-geo-alt-fill"></i>

                  <div style={{ flex: 1 }}>
                    <div className="zzx_sf-label">Hotel</div>

                    <div className="d-flex align-items-center">
                      <input
                        type="text"
                        className="border-0 bg-transparent w-100"
                        placeholder="Search Hotel"
                        value={selectedHotel?.DisplayName || hotelSearch}
                        onChange={(e) => {
                          setHotelSearch(e.target.value);
                          setSelectedHotel(null);
                          setShowHotelDropdown(true);
                        }}
                        onClick={() => setShowHotelDropdown(true)}
                        style={{
                          outline: "none",
                          boxShadow: "none",
                        }}
                      />

                      {(selectedHotel || hotelSearch) && (
                        <button
                          type="button"
                          className="btn btn-sm p-0 ms-2"
                          onClick={(e) => {
                            e.stopPropagation();
                            setSelectedHotel(null);
                            setHotelSearch("");
                            setShowHotelDropdown(false);
                          }}
                        >
                          <i className="bi bi-x-lg"></i>
                        </button>
                      )}
                    </div>
                  </div>

                  {/* Dropdown */}
                  {showHotelDropdown && (
                    <div
                      className="zzx_hotel-dropdown"
                      onClick={(e) => e.stopPropagation()}
                    >
                      {filteredProperties?.length > 0 ? (
                        filteredProperties.map((item) => (
                          <div
                            key={item.PropertyID}
                            className="zzx_hd-item"
                            onClick={() => {
                              setSelectedHotel(item);
                              setHotelSearch("");
                              setShowHotelDropdown(false);
                            }}
                          >
                            <div className="zzx_hd-icon">
                              <i className="bi bi-building"></i>
                            </div>

                            <div>
                              <div className="zzx_hd-city">
                                {item.DisplayName}
                              </div>
                            </div>
                          </div>
                        ))
                      ) : (
                        <div className="p-2 text-center">
                          No hotel found
                        </div>
                      )}
                    </div>
                  )}
                </div>

                {/* DATE PICKER */}
                <div
                  className="zzx_search-field position-relative"
                  onClick={openPicker}
                  style={{ cursor: "pointer" }}
                >
                  <i className="bi bi-calendar3" />

                  <div>
                    <div className="zzx_sf-label">
                      Check-in / Check-out
                    </div>

                    <div className="zzx_sf-value">
                      {dateValue}
                    </div>
                  </div>

                  {/* Hidden Input */}
                  <input
                    ref={inputRef}
                    type="text"
                    name="datefilter"
                    className="position-absolute top-0 start-0 w-100 h-100 opacity-0"
                    style={{
                      cursor: "pointer",
                    }}
                    readOnly
                  />
                </div>

                {/* GUEST DROPDOWN */}
                <div
                  className="zzx_search-field position-relative"
                  style={{
                    borderRight: "none",
                    cursor: "pointer",
                  }}
                  ref={guestDropdownRef}
                  onClick={() =>
                    setShowGuestDropdown(!showGuestDropdown)
                  }
                >
                  <i className="bi bi-people-fill" />

                  <div>
                    <div className="zzx_sf-label">
                      Guests & Rooms
                    </div>

                    <div className="zzx_sf-value">
                      {adults} Adults · {children} Children · {rooms} Room
                    </div>
                  </div>

                  {/* DROPDOWN */}
                  {showGuestDropdown && (
                    <div
                      className="position-absolute bg-white shadow"
                      style={{
                        top: "110%",
                        right: 0,
                        width: "320px",
                        padding: "20px",
                        zIndex: 9999,
                        border: "1px solid #eee",
                        borderRadius: "14px",
                      }}
                      onClick={(e) => e.stopPropagation()}
                    >
                      <Counter
                        label="Adults"
                        value={adults}
                        setValue={setAdults}
                        min={1}
                      />

                      <Counter
                        label="Children"
                        value={children}
                        setValue={setChildren}
                        min={0}
                      />

                      <Counter
                        label="Rooms"
                        value={rooms}
                        setValue={setRooms}
                        min={1}
                      />
                    </div>
                  )}
                </div>
              </div>

              {/* SEARCH BUTTON */}
              <button className="zzx_btn-search" onClick={handleSearch}>
                <i className="bi bi-search me-2" />
                Search
              </button>
            </div>
          </div>
        </div>
      </section>

    </>
  );
};